import { create } from 'zustand';
import { readStoredWidth } from '@/constants/workflow-editor';

export const SCHEDULE_LIST_WIDTH_KEY = 'schedules-list-panel-width';
export const RUNS_FEED_WIDTH_KEY = 'schedules-runs-feed-panel-width';

export const SCHEDULE_LIST_MIN_WIDTH = 260;
export const SCHEDULE_LIST_MAX_WIDTH = 480;
export const SCHEDULE_LIST_DEFAULT_WIDTH = SCHEDULE_LIST_MIN_WIDTH;

export const RUNS_FEED_MIN_WIDTH = 300;
export const RUNS_FEED_MAX_WIDTH = 560;
export const RUNS_FEED_DEFAULT_WIDTH = RUNS_FEED_MIN_WIDTH;

interface SchedulesLayoutState {
  scheduleListWidth: number;
  runsFeedWidth: number;
  setScheduleListWidth: (px: number) => void;
  setRunsFeedWidth: (px: number) => void;
}

function persist(key: string, min: number, max: number, px: number): number {
  const clamped = Math.round(Math.max(min, Math.min(max, px)));
  try {
    localStorage.setItem(key, String(clamped));
  } catch {
    // localStorage may be unavailable
  }
  return clamped;
}

export const useSchedulesLayoutStore = create<SchedulesLayoutState>((set) => ({
  scheduleListWidth: readStoredWidth(
    SCHEDULE_LIST_WIDTH_KEY,
    SCHEDULE_LIST_DEFAULT_WIDTH,
  ),
  runsFeedWidth: readStoredWidth(RUNS_FEED_WIDTH_KEY, RUNS_FEED_DEFAULT_WIDTH),
  setScheduleListWidth: (px) =>
    set({
      scheduleListWidth: persist(
        SCHEDULE_LIST_WIDTH_KEY,
        SCHEDULE_LIST_MIN_WIDTH,
        SCHEDULE_LIST_MAX_WIDTH,
        px,
      ),
    }),
  setRunsFeedWidth: (px) =>
    set({
      runsFeedWidth: persist(
        RUNS_FEED_WIDTH_KEY,
        RUNS_FEED_MIN_WIDTH,
        RUNS_FEED_MAX_WIDTH,
        px,
      ),
    }),
}));
